import { isMobile } from 'react-device-detect'
import { sendGAEvent } from '@lib/ga4'
import { useIsAppControl } from '@store/isApp'

const useSendElectionBanner = () => {
	const { appInfo } = useIsAppControl()

	const sendElectionBanner = (name: string, params?: object) => {
		if (appInfo?.DType === 'A') {
			sendGAEvent(name, { ...params, type: 'AOS' })
			return
		}
		if (appInfo?.DType === 'I') {
			sendGAEvent(name, { ...params, type: 'IOS' })
			return
		}
		if (appInfo?.DType === 'W') {
			sendGAEvent(name, { ...params, type: isMobile ? 'MOBILE_WEB' : 'PC_WEB' })
		}
	}

	return {
		sendElectionBanner,
	}
}
export default useSendElectionBanner
